import Invoice from '../models/Invoice';
import {useUxStore} from "@/stores/uxStore";
import apiClient from "@/axiosConfig";


const getUxStore = () => useUxStore();


export default {
    async getInvoices(page = 1, filter = {}) {
        const response = await apiClient.get('/invoice', {params: {page, ...filter}});
        // Convert each returned item to an Invoice instance
        return response.data.map(invoiceData => new Invoice(invoiceData));
    },

    async getInvoice(id) {
        return apiClient.get(`/invoice/${id}`);
    },

    async getInvoiceFromFile(fileId, selectedParserId, invoiceTypeId, ocrEngineTypeId = null) {
        try {
            getUxStore().startLoading();

            const params = {
                InvoiceParserTypeId: selectedParserId,
            }
            if (invoiceTypeId) {
                params.InvoiceTypeId = invoiceTypeId
            }
            if (ocrEngineTypeId) {
                params.OcrEngineTypeId = ocrEngineTypeId
            }

            const response = await apiClient.get(`/invoice/FromFile/${fileId}`, {params});
            console.log(response, "response")
            if (response.data && response.data.parsingErrors && Object.keys(response.data.parsingErrors).length > 0) {
                getUxStore().setParsingErrors(response.data.parsingErrors);
                if(response.data.parsingErrors['GrossTotalAmount']){
                    getUxStore().setError(response.data.parsingErrors['GrossTotalAmount'])
                    //getUxStore().setError(response.data.parsingErrors)
                }
            }else {
                getUxStore().clearParsingErrors();
            }
            return new Invoice(response.data.invoice);
        } catch (error) {
            console.error("Error in InvoiceService.getInvoiceFromFile:", error);

            const responseData = error?.response?.data;
            const detailMessage = typeof responseData === "string"
                ? responseData
                : (responseData?.detail || responseData?.title || responseData?.message);

            getUxStore().setError(detailMessage || "Error fetching invoice data");
            return null;
        } finally {
            getUxStore().stopLoading();
        }

    },

    async createInvoice(invoiceData) {
        const invoice = new Invoice(invoiceData);
        return apiClient.post('/invoice', invoice.toJSON());
    },

    async editInvoice(id, invoiceData) {
        const invoice = new Invoice(invoiceData);
        return apiClient.put(`/invoice/${id}`, invoice.toJSON());
    },

    async deleteInvoice(id) {
        return apiClient.delete(`/invoice/${id}`);
    },

    async downloadInvoice(id) {
        return apiClient.get(`/invoice/${id}/download`, {responseType: 'blob'});
    }
};
